//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {}
    },
    props: {
        title: [String, Number],
        lableWidth:[String]
    },
    created() {},
    methods:{
    }
}
